import React from 'react';

import {skipToken} from '@reduxjs/toolkit/query';
import {convertNodeToElement} from 'react-html-parser';

import {useAccountSettings} from 'app/settings/api';
import {markAsSafe} from 'app/utils/strings';
import {useOembed} from 'app/video/api';

import {getRatio, StyledEmbeddedContainerDiv} from '../../EmbeddedObject';

import type {HtmlDocType} from '../node-processors-types';

interface Props {
  node: HtmlDocType;
}

export const EmbedlyVideo = ({node}: Props) => {
  const EMBEDLY_KEY = useAccountSettings(undefined, {
    refetchOnMountOrArgChange: 900,
  }).data?.EMBEDLY_KEY;

  const {data: oembed} = useOembed(
    EMBEDLY_KEY != null ? {key: EMBEDLY_KEY, url: node.attribs.href} : skipToken
  );

  if (oembed != null && oembed.type === 'video') {
    const {width, height} = oembed;
    return (
      <StyledEmbeddedContainerDiv
        style={{
          width,
          height,
        }}
      >
        {oembed.html != null ? (
          <div
            className="embedded-obj"
            style={{
              paddingBottom: getRatio(width, height),
            }}
            dangerouslySetInnerHTML={markAsSafe(oembed.html)}
          />
        ) : null}
      </StyledEmbeddedContainerDiv>
    );
  } else if (oembed != null && oembed.type === 'link') {
    return convertNodeToElement(node, 1, () => undefined);
  }

  return convertNodeToElement(node, 1, () => null);
};
